import React from "react";
import Button from "../atoms/Button";
import Text from "../atoms/Text";
import Input from "../molecules/Input";
import { ProfileAvatar } from "./ProfileShared";

function renderField(label, field) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
      <Text
        size="px12"
        weight="w400"
        color="gray9"
        extraStyles={{ display: "block", textAlign: "start", width: "100%" }}
      >
        {label}
      </Text>
      {field}
    </div>
  );
}

function renderSelect(value, onChange, placeholder, options) {
  return (
    <div style={{ position: "relative" }}>
      <select
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          height: "49px",
          border: "1px solid var(--gray1)",
          borderRadius: "6px",
          padding: "0 40px 0 16px",
          appearance: "none",
          outline: "none",
          color: value ? "var(--gray9)" : "var(--gray4)",
          fontFamily: "inherit",
          fontSize: "14px",
          backgroundColor: "var(--white)",
        }}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <span
        style={{
          position: "absolute",
          right: "16px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "var(--gray5)",
          pointerEvents: "none",
          fontSize: "12px",
        }}
      >
        v
      </span>
    </div>
  );
}

export default function SettingsProfile({
  currentUser,
  settingsFocus,
  fileInputRef,
  accountForm,
  setAccountForm,
  billingForm,
  setBillingForm,
  passwordForm,
  setPasswordForm,
  cityOptions,
  countryOptions,
  onProfileImageChange,
  onAccountSave,
  onBillingSave,
  onPasswordSave,
}) {
  const isAccountFocused = settingsFocus === "account";
  const isAddressFocused = settingsFocus === "address";
  const isPasswordFocused = settingsFocus === "password";

  return (
    <div className="settings-profile" style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <div
        className="settings-profile-account"
        style={{
          border: `1px solid ${isAccountFocused ? "var(--primary)" : "var(--gray1)"}`,
          borderRadius: "8px",
          backgroundColor: "var(--white)",
          padding: "24px",
          display: "grid",
          gridTemplateColumns: "1fr 220px",
          gap: "24px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Text size="px20" weight="w500" color="gray9">
            Account Settings
          </Text>
          <div className="settings-profile-grid settings-profile-grid--two" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
            {renderField(
              "First name",
              <Input
                placeholder="First name"
                value={accountForm.firstName}
                onChange={(event) =>
                  setAccountForm((currentForm) => ({
                    ...currentForm,
                    firstName: event.target.value,
                  }))
                }
                width="100%"
              />,
            )}
            {renderField(
              "Last name",
              <Input
                placeholder="Last name"
                value={accountForm.lastName}
                onChange={(event) =>
                  setAccountForm((currentForm) => ({
                    ...currentForm,
                    lastName: event.target.value,
                  }))
                }
                width="100%"
              />,
            )}
          </div>
          {renderField(
            "Display name",
            <Input
              placeholder="Display name"
              value={accountForm.displayName}
              onChange={(event) =>
                setAccountForm((currentForm) => ({
                  ...currentForm,
                  displayName: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
          {renderField(
            "Email",
            <Input
              type="email"
              placeholder="Email address"
              value={accountForm.email}
              onChange={(event) =>
                setAccountForm((currentForm) => ({
                  ...currentForm,
                  email: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
          {renderField(
            "Phone Number",
            <Input
              placeholder="Phone number"
              value={accountForm.phone}
              onChange={(event) =>
                setAccountForm((currentForm) => ({
                  ...currentForm,
                  phone: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
          <Button size="small" variant="fill" onClick={onAccountSave}>
            Save Changes
          </Button>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "18px",
          }}
        >
          <ProfileAvatar currentUser={{ ...currentUser, pfp: currentUser?.pfp }} />
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            onChange={onProfileImageChange}
            style={{ display: "none" }}
          />
          <Button
            size="small"
            variant="border"
            onClick={() => fileInputRef.current?.click()}
            style={{
              minWidth: "120px",
              minHeight: "36px",
              fontSize: "12px",
            }}
          >
            Choose Image
          </Button>
        </div>
      </div>

      <div
        className="settings-profile-billing"
        style={{
          border: `1px solid ${isAddressFocused ? "var(--primary)" : "var(--gray1)"}`,
          borderRadius: "8px",
          backgroundColor: "var(--white)",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Text size="px20" weight="w500" color="gray9">
          Billing Address
        </Text>
        <div className="settings-profile-grid settings-profile-grid--three" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px" }}>
          {renderField(
            "First name",
            <Input
              placeholder="Your first name"
              value={billingForm.firstName}
              onChange={(event) =>
                setBillingForm((currentForm) => ({
                  ...currentForm,
                  firstName: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
          {renderField(
            "Last name",
            <Input
              placeholder="Your last name"
              value={billingForm.lastName}
              onChange={(event) =>
                setBillingForm((currentForm) => ({
                  ...currentForm,
                  lastName: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
          {renderField(
            "Company Name (optional)",
            <Input
              placeholder="Company name"
              value={billingForm.companyName}
              onChange={(event) =>
                setBillingForm((currentForm) => ({
                  ...currentForm,
                  companyName: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
        </div>
        {renderField(
          "Street Address",
          <Input
            placeholder="Street Address"
            value={billingForm.address}
            onChange={(event) =>
              setBillingForm((currentForm) => ({
                ...currentForm,
                address: event.target.value,
              }))
            }
            width="100%"
          />,
        )}
        <div className="settings-profile-grid settings-profile-grid--three" style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px" }}>
          {renderField(
            "Country / Region",
            renderSelect(
              billingForm.country,
              (event) =>
                setBillingForm((currentForm) => ({
                  ...currentForm,
                  country: event.target.value,
                  city: "",
                })),
              "Select",
              countryOptions,
            ),
          )}
          {renderField(
            "Cities",
            renderSelect(
              billingForm.city,
              (event) =>
                setBillingForm((currentForm) => ({
                  ...currentForm,
                  city: event.target.value,
                })),
              "Select city",
              cityOptions,
            ),
          )}
          {renderField(
            "Zip Code",
            <Input
              placeholder="Zip Code"
              value={billingForm.zipCode}
              onChange={(event) =>
                setBillingForm((currentForm) => ({
                  ...currentForm,
                  zipCode: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
        </div>
        <div className="settings-profile-grid settings-profile-grid--two" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
          {renderField(
            "Email",
            <Input
              type="email"
              placeholder="Email Address"
              value={billingForm.email}
              onChange={(event) =>
                setBillingForm((currentForm) => ({
                  ...currentForm,
                  email: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
          {renderField(
            "Phone",
            <Input
              placeholder="Phone number"
              value={billingForm.phone}
              onChange={(event) =>
                setBillingForm((currentForm) => ({
                  ...currentForm,
                  phone: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
        </div>
        <Button size="small" variant="fill" onClick={onBillingSave}>
          Save Changes
        </Button>
      </div>

      <div
        className="settings-profile-password"
        style={{
          border: `1px solid ${isPasswordFocused ? "var(--primary)" : "var(--gray1)"}`,
          borderRadius: "8px",
          backgroundColor: "var(--white)",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Text size="px20" weight="w500" color="gray9">
          Change Password
        </Text>
        {renderField(
          "Current Password",
          <Input
            type="password"
            placeholder="Password"
            value={passwordForm.currentPassword}
            onChange={(event) =>
              setPasswordForm((currentForm) => ({
                ...currentForm,
                currentPassword: event.target.value,
              }))
            }
            width="100%"
          />,
        )}
        <div className="settings-profile-grid settings-profile-grid--two" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px" }}>
          {renderField(
            "New Password",
            <Input
              type="password"
              placeholder="Password"
              value={passwordForm.newPassword}
              onChange={(event) =>
                setPasswordForm((currentForm) => ({
                  ...currentForm,
                  newPassword: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
          {renderField(
            "Confirm Password",
            <Input
              type="password"
              placeholder="Password"
              value={passwordForm.confirmPassword}
              onChange={(event) =>
                setPasswordForm((currentForm) => ({
                  ...currentForm,
                  confirmPassword: event.target.value,
                }))
              }
              width="100%"
            />,
          )}
        </div>
        <Button size="small" variant="fill" onClick={onPasswordSave}>
          Change Password
        </Button>
      </div>
    </div>
  );
}
